export default __webpack_public_path__ + "static/media/500.d41c5d7e.png";